import Button from "@/Components/Button/Button";
import Modal, { ModalProps } from "@/Components/Modal/Modal";
import Select from "@/Components/Select/Select";
import useCouriersHook from "@/shared/hooks/useCouriersHook";
import useGetCourierJWT from "@/shared/queries/cmsAccount/useGetCourierJWT";
import { userRoles } from "@/shared/utils/constant";
import { CmsUsersResponse } from "@/shared/utils/interfaces";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";

const CourierQrLoginModal = ({ onExit, ...props }: ModalProps) => {
  const { t } = useTranslation();
  const allCouriers = useCouriersHook();
  const couriers = useMemo(
    () =>
      allCouriers.filter((c) => c.roles?.includes(userRoles.ROLE_COURIER)),
    [allCouriers]
  );
  const [courier, setCourier] = useState<CmsUsersResponse | undefined>();
  const { data, isFetching } = useGetCourierJWT(courier?.item_id);

  return (
    <Modal width={"58rem"} onExit={onExit} {...props}>
      <h1>{t("mapOrder.courierQrLogin")}</h1>
      <p className="mb-[2rem]">{t("mapOrder.courierQrLoginDescription")}</p>
      <div className="mb-[2rem]">
        <Select
          value={courier}
          onChange={(option) => setCourier(option)}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.item_id}
          options={couriers}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          menuPortalTarget={document.getElementById("root")}
          placeholder={t("mapOrder.chooseCourier")}
        />
      </div>
      {courier !== undefined && data && !isFetching && (
        <div className="mb-[2rem]">
          <QRCode
            level="L"
            style={{ height: "auto", maxWidth: "50rem", width: "100%" }}
            value={JSON.stringify(data)}
            viewBox={`0 0 256 256`}
          />
        </div>
      )}
      <Button onClick={() => onExit()}>{t("close")}</Button>
    </Modal>
  );
};

export default CourierQrLoginModal;
